import { Box, Heading } from '@zillow/constellation-10';
import { Col } from '@zg-rentals/zrs-comet';
import Bone from '../../Bone';
import SkeletonContainer from '../../SkeletonContainer';

const SkeletonReply = (): JSX.Element => {
  return (
    <>
      <Col xs={4}>
        <Bone dark={true} type="line" />
        <br />
      </Col>

      <Col xs={12}>
        <Bone dark={true} type="line" />
        <br />
      </Col>

      <Box css={{ marginBottom: 'default' }} />
    </>
  );
};

const Skeleton = (): JSX.Element => {
  return (
    <SkeletonContainer>
      <>
        <Heading level={2} textStyle="heading-xs" css={{ marginTop: 'default', marginBottom: 'default' }}>
          My replies
        </Heading>

        <SkeletonReply />
        <SkeletonReply />
        <SkeletonReply />
        <SkeletonReply />
        <SkeletonReply />
      </>
    </SkeletonContainer>
  );
};

export default Skeleton;
